const LOGO_URL = "/logo.png";

export default function Logo({ className = "", alt = "The Sim Guys" }) {
  return (
    <img
      src={LOGO_URL}
      alt={alt}
      className={className}
      loading="eager"
      decoding="async"
    />
  );
}
